module.exports = __webpack_public_path__ + "static/media/banner.a382d999.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep17/banner.png
 ** module id = 216
 ** module chunks = 0
 **/